/**
 * V5.2: Visitor ID management for AI generation gating
 * Generates UUID on first use and stores in cookie
 */

export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function getOrCreateVisitorId() {
  const cookieName = 'visitor_id';
  
  // Check if visitor_id cookie exists
  const cookies = document.cookie.split(';').map(c => c.trim());
  for (const cookie of cookies) {
    const [name, value] = cookie.split('=');
    if (name === cookieName && value) {
      return value;
    }
  }
  
  // Generate new UUID
  const visitorId = generateUUID();
  
  // Set cookie (expires in 1 year)
  const expiryDate = new Date();
  expiryDate.setFullYear(expiryDate.getFullYear() + 1);
  document.cookie = `${cookieName}=${visitorId}; expires=${expiryDate.toUTCString()}; path=/`;
  
  return visitorId;
}

export function getVisitorIdFromCookie() {
  const cookies = document.cookie.split(';').map(c => c.trim());
  for (const cookie of cookies) {
    const [name, value] = cookie.split('=');
    if (name === 'visitor_id' && value) {
      return value;
    }
  }
  return null;
}
